import React from 'react';
import Layout from '../components/Layout/Layout';
import placementCellImg from '../images/PLACEMENTCELL-PHOTO.jpg';

const PlacementCellPage = () => {
  return (
    <Layout>
      <div id="placement-cell" className="page-container" style={{ maxWidth: '900px', margin: '40px auto', padding: '0 20px', minHeight: '500px' }}>
        
        <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '30px', textAlign: 'center', fontSize: '2rem', fontWeight: 'bold' }}>
          Placement Cell
        </h2>

        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', display: 'flex', justifyContent: 'center' }}>
          <img 
            src={placementCellImg} 
            alt="Placement Cell Details" 
            style={{ width: '100%', height: 'auto', borderRadius: '8px', border: '1px solid #eee' }} 
          />
        </div>

      </div>
    </Layout>
  );
};

export default PlacementCellPage;
